import { locationsReducer } from './services/locations.service';
import { sharedReducer } from './services/shared-programming.service';
import { itemsReducer } from './services/items.service';
import { programmingEventsReducer } from './services/events.service';

export const COMMON_PROGRAMMING_REDUCERS: any = {
  programmingItems: itemsReducer,
  sharedProgramming: sharedReducer,
  locations: locationsReducer,
  programmingEvents: programmingEventsReducer
};



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/common.stores.ts